import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Modal from "react-bootstrap/Modal";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken , } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Select from "react-select";
import PropTypes from 'prop-types';

import Swal from 'sweetalert2';
import {
  Box,
  MenuItem,
} from '@mui/material';
import "react-toastify/dist/ReactToastify.css";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
const Customers = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [incotermsList, setIncotermsList] = useState([]);
  const [permission, setPermission] = useState({});
  const handleClose = () => setShow(false);
  const handleShow = (itemId) => {
    setSelectedItemId(itemId);
    setShow(true);
  };
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  handleShow


  const deleteItem = (item) => {

    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/customers/delete/${item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/customers";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }
  
  
  const [formData, setFormData] = useState({
    name:'',
    email: '',
    phone_number: '',
    incoterm:''
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(formData);
    axios
    .post("/customers/listing", formData, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }) .then((response) => {
   

      if (response.data.code === 200) {
        setData(response.data.data.customers);
      } 
      else {
         //setBackendErrors(response.data.error);
      }
    })
    .catch((error) => {
      console.log(error)
     // actions.setSubmitting(false);
    });
  
  }
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    console.log(Input_name);
    // delete backendErrors[Input_name];
  };



  useEffect(() => {
        setPermission(FindModuleById(2)); 
        console.log(permission);

   
    axios
    .get(
      `/helpers/incoterms`,

      {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      }
    )
    .then((response) => {
      if (response.data.code === 200) {
        let incoterms = response.data.data.incoterms;
        let incotermslisting = incoterms.map((cust, index) => ({
          label: cust.title,
          value: cust.id,
          key: `types-${index}`,
        }));
        setIncotermsList(incotermslisting);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });
    axios
      .post(
        "/customers/listing",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.customers);
        }else{
          window.location.href = "/login";
        }
       
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
 AWS.config.setPromisesDependency();
  AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
  });
  
   const s3 = new AWS.S3();
   const EmployeeCell = ({ renderedCellValue, row }) => {
     const profilePicture = row?.original?.company_logo || '';
     const employeeId = row?.original?.id || '';
     let url = '';
   
     if (profilePicture) {
       const params = { Bucket: AWS_BUCKET, Key: profilePicture };
       url = s3.getSignedUrl('getObject', params);
     }
     return (
       <a href={`/customers-view/${employeeId}`} className="">
         <Box
           sx={{
             display: 'flex',
             alignItems: 'center',
             gap: '1rem',
           }}
         >
           <img
             alt="avatar"
             height={70}
             width={70}
             src={url}
             loading="lazy"
             style={{ borderRadius: '100%' }}
           />
           <span>{renderedCellValue}</span>
         </Box>
       </a>
     );
   };
   EmployeeCell.propTypes = {
     renderedCellValue: PropTypes.string.isRequired,
     row: PropTypes.shape({
       original: PropTypes.shape({
         id: PropTypes.number.isRequired,
         company_logo: PropTypes.string,
       }).isRequired,
     }).isRequired,
   };
  const columns =
  [
    {
      header: 'Full Name',
      accessorFn: (row) => `${row.company_name}`,
      Cell: EmployeeCell,
    },
    
    {
      accessorKey: 'company_email',
      header: 'Email',
    },
    {
      accessorKey: 'company_phone', //normal accessorKey
      header: 'Phone Number',
    },
    {
      accessorKey: 'company_website', //normal accessorKey
      header: 'Website',
    },
    {
      header: 'Incoterm',
      accessorFn: (row) => `${(row.incoterm_name)?row.incoterm_name.title:""} `,
    },
    {
      header: 'Currency',
      accessorFn: (row) => `${(row.currency)?row.currency.title:""} `,
    },
    {
      accessorKey: 'vat', //normal accessorKey
      header: 'VAT',
    },
    {
      header: 'Payment Terms',
      accessorFn: (row) => `${(row.payment_terms)?row.payment_terms.name:""} `,
    },
    {
      header: 'Created By',
      accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
    },
    {
      header: 'Updated By',
      accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
    },

   ];




  const editItem = (item)=>{
    window.location.href = "/customers-edit/"+item;
  }
  const handleSelectChangeCustomer = (selectedOption) => {
    setFormData({ ...formData, incoterm: selectedOption ? selectedOption.value : null });
  };
  

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          <div className="text-center">
            <h3>Delete Customer</h3>
            <p>Do you really want to delete?</p>
          </div>
          <div className="row pt-3">
            <div className="col-6">
              <button
                onClick={() => deleteItem(selectedItemId)}
                type="reset"
                data-bs-dismiss="modal"
                className="w-100 btn btn-primary"
              >
                Delete
              </button>
            </div>
            <div className="col-6">
              <button
                onClick={handleClose}
                type="submit" id="form-submit"
                data-bs-dismiss="modal"
                className="w-100 btn btn-secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Customers</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">Customers</li>
                  </ul>
                </div>
                <div className="col-auto">
                  
                  {permission && permission.add === 1 && (
                   <Link to="/customers-add" className="btn btn-primary me-1">
                   <i className="fas fa-plus"></i>
                 </Link>
                )} 
               

                 
                 
                </div>
              </div>
            </div>
            <div id="filter_inputs" className="card filter-card2">
              <div className="card-body p-10">
                <form onSubmit={handleSubmit}>
                <div className="row">
               
                 
                
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Customer Name:</label>
                      <input type="text" name="name" placeholder="Customer Name" className="form-control"  value={formData.name} onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}  />
                    </div>
                  </div>
                
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Email:</label>
                      <input type="email" name="email" placeholder="Email Address" className="form-control"  value={formData.email} onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}  />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Phone Number:</label>
                      <input type="text" name="phone_number" placeholder="Phone Number" className="form-control"  value={formData.phone_number} onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}  />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Select Incoterms:</label>
                    
                        <Select
                           options={incotermsList}
                           name="customer"
                           value={incotermsList.find(option => option.value === formData.incoterm) || null} 
                           onChange={(selectedOption) => handleSelectChangeCustomer(selectedOption)}
                          />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                      &nbsp;&nbsp;
                      <a href="/customers" className="btn btn-primary me-1"><i className="fa fa-times"></i></a>
                    </div>
                  </div>
                </div>
                </form>
                
              </div>
            </div>
         
            <div className="row">
              <div className="col-sm-12">
              {permission && permission.list === 1 && ( 
                <div className="card card-table">
                  <div className="card-body">
                  <div className="table-responsive">

                    <MaterialReactTable columns={columns} data={data} 
                        enableColumnOrdering
                        enablePinning
                        enableRowActions
                        renderRowActionMenuItems={({ row }) => [
                          permission?.update === 1 && (
                            <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                              Edit
                            </MenuItem>
                          ),
                          permission?.delete === 1 && (
                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                              Delete
                            </MenuItem>
                          ),
                        ]}
                      />
                    </div>
                    
                  
                  </div>
                </div>
              )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Customers;
